import angular from 'angular';
import CompleteRegistrationComponent from './complete-registration-component';

export default angular
  .module('complete-registration', ['rw-captcha'])
  .component('completeRegistration', new CompleteRegistrationComponent());



// WEBPACK FOOTER //
// ./src/modules/registration/components/complete-registration/complete-registration-module.js